import React, { useMemo } from 'react'
import Page from '../_library/Page'
import TeamTable from './TeamTable'
import { useSelector } from 'react-redux'
import Breadcrumbs from '../_library/Breadcrumbs'
import useFirestore from '../../hooks/useFirestore'
import { COMPANY_COLLECTION } from '../../_constants/globals'


const TeamPage = () => {

  const companyHooks = useFirestore(COMPANY_COLLECTION)
  const companies = companyHooks.getDocs()
  const selectedCompanyId = useSelector(state => state.data.selectedCompanyId)

  const selectedCompany = useMemo(() => companies?.find(c => c.id === selectedCompanyId), [companies, selectedCompanyId])

  return (
    <Page title='Tableau de bord - Equipes'>
      <Breadcrumbs />
      <TeamTable company={selectedCompany} />
    </Page>
  )
}

export default TeamPage
